module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M5 6h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm18 22H5a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2zm0-4H5a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2zm0-4H5a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2zm0-4H5a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2zm-4-6a1 1 0 0 1-1-1V1a1 1 0 0 0-1-1H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h24c1.106 0 2-.894 2-2V11a1 1 0 0 0-1-1h-8zm1-9v6a1 1 0 0 0 1 1h6c.552 0 .684-.316.292-.708L20.706.706C20.316.316 20 .448 20 1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/document-4.js
// module id = 1103
// module chunks = 14